module.exports = __webpack_public_path__ + "static/media/mblink.9948937c.bmp";